import React from 'react';
import { Box, Button, Tooltip } from '@mui/material';
import { Send as SendIcon } from '@mui/icons-material';
import { DeleteConfirmation } from 'components/DeleteConfirmation';
import { BackstoryTextField, BackstoryTextFieldRef } from 'components/BackstoryTextField';
import { ChatSession } from 'types/types';

interface ResumeChatInputProps {
  chatSession: ChatSession | null;
  textRef: React.RefObject<BackstoryTextFieldRef | null>;
  streaming: boolean;
  loading: boolean;
  onDelete: (session: ChatSession) => void;
  onSend: (message: string) => void;
}

export function ResumeChatInput({
  chatSession,
  textRef,
  streaming,
  loading,
  onDelete,
  onSend,
}: ResumeChatInputProps): React.ReactElement {
  const disabled = streaming || loading;
  return (
    <Box
      sx={{
        display: 'flex',
        flexGrow: 1,
        gap: 1,
        position: 'relative',
        width: '100%',
        minWidth: '100%',
        flexDirection: 'row',
        overflow: 'hidden',
      }}
    >
      <DeleteConfirmation
        onDelete={(): void => {
          chatSession && onDelete(chatSession);
        }}
        disabled={!chatSession}
        sx={{ minWidth: 'auto', px: 2, maxHeight: 'min-content' }}
        action="reset"
        label="chat session"
        title="Reset Chat Session"
        message="Are you sure you want to reset the session? This action cannot be undone."
      />
      <BackstoryTextField
        placeholder="What would you like to change about this resume?"
        ref={textRef}
        onEnter={onSend}
        disabled={disabled}
      />
      <Tooltip title="Send">
        <span style={{ minWidth: 'auto', maxHeight: 'min-content', alignSelf: 'center' }}>
          <Button
            variant="contained"
            onClick={(): void => {
              onSend((textRef.current && textRef.current.getAndResetValue()) || '');
            }}
            disabled={disabled}
          >
            <SendIcon />
          </Button>
        </span>
      </Tooltip>
    </Box>
  );
}
